import { supabase } from './supabase';

// Reduce la foto a un cuadrado de 320px (JPEG) antes de subirla
const toSquareBlob = (file, size = 320) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    const s = Math.min(img.width, img.height);
    const c = document.createElement('canvas'); c.width = size; c.height = size;
    c.getContext('2d').drawImage(img, (img.width - s) / 2, (img.height - s) / 2, s, s, 0, 0, size, size);
    URL.revokeObjectURL(url);
    c.toBlob((b) => (b ? resolve(b) : reject(new Error('No se pudo procesar la foto'))), 'image/jpeg', 0.85);
  };
  img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Ese archivo no es una imagen válida')); };
  img.src = url;
});

export const uploadAvatar = async (file, orgId, userId) => {
  if (!file || !file.type.startsWith('image/')) throw new Error('Elegí una imagen (JPG o PNG)');
  const blob = await toSquareBlob(file);
  const path = `${orgId}/${userId}.jpg`;
  const { error } = await supabase.storage.from('avatars').upload(path, blob, { upsert: true, contentType: 'image/jpeg' });
  if (error) throw new Error(error.message);
  const { error: e2 } = await supabase.from('profiles').update({ avatar_path: path }).eq('id', userId);
  if (e2) throw new Error(e2.message);
  return path;
};

// paths: { userId: path } -> { userId: urlFirmada }
export const signAvatars = async (map) => {
  const ids = Object.keys(map).filter((k) => map[k]);
  if (!ids.length) return {};
  const { data, error } = await supabase.storage.from('avatars').createSignedUrls(ids.map((k) => map[k]), 3600);
  if (error || !data) return {};
  const out = {};
  data.forEach((r, i) => { if (r.signedUrl) out[ids[i]] = r.signedUrl; });
  return out;
};
